<div class="row">
  <div class="col-md-6 col-xxxl-4" *ngFor="let number of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]">
    <ngx-skeleton-loader count="1" [theme]="{ 'border-radius': '5px', height: '18rem' }"></ngx-skeleton-loader>
    <div>
      <ngx-skeleton-loader
        [theme]="{
          width: '80%',
          'border-radius': '0',
          height: '20px',
          'margin-bottom': '3px'
        }"
      ></ngx-skeleton-loader>
    </div>
    <div>
      <ngx-skeleton-loader [theme]="{ width: '90%', 'border-radius': '0', height: '15px', 'margin-bottom': '20px' }"> </ngx-skeleton-loader>
    </div>
  </div>
</div>
